import React from 'react';

// IMAGES
import headerIcon from '../../../../static/img/img-ihr-by-bodymatter-hr-logo-black-sm@3x.png';
import blueCheck from '../../../../static/img/icon-checkmark-full-knockout-lm@3x.png';

// STYLES
import './CongratsLander.scss';

// HOOKS
import { useAuthContext } from '../../../../hooks/context/AuthContext';

const CongratsLander: React.FC = () => {
  const { maskedEmailAddress } = useAuthContext();
  return (
    <div className="CongratsLander">
      <div className="CongratsLander__content">
        <img
          src={headerIcon}
          loading="lazy"
          alt="Instant Heart Rate"
          className="CongratsLander__logo"
        />

        <img
          src={blueCheck}
          loading="lazy"
          alt="Check"
          className="CongratsLander__check"
        />

        <h4 className="CongratsLander__title">Congrats!</h4>
        <p className="CongratsLander__message">
          Your Premium benefits are now available.
        </p>
        <h6 className="CongratsLander__desktop-instruction">
          <b>To continue, open Instant Heart Rate on your Apple device.</b>
        </h6>
        <button
          className="CongratsLander__button"
          type="button"
          onClick={() => {
            const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
            if (url) {
              window.location.assign(url);
            } else {
              console.error('Missing REACT_APP_UNIVERSAL_DEEP_LINK');
            }
          }}
        >
          Open Instant Heart Rate
        </button>

        <div className="CongratsLander__divider"></div>

        <div className="CongratsLander__direction-wrapper">
          <h6>Not seeing your Premium benefits?</h6>
          <p>Make sure you're logged in as:</p>
          <h6 className="masked-email">{maskedEmailAddress}</h6>
          {/* <h6 className="masked-email">{maskedEmailAddress}</h6> */}
          <p>and then go to:</p>
          <div>
            <i>
              More Tab {'>'} Account {'>'} Sync Purchases
            </i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CongratsLander;
